<template>
    <div class="bg">
        <div class="container">
            <h1>DJOS - Обратная связь по новым блюдам</h1>
            <v-alert
                v-if="popup === true"
                :color="classPopUp"
                :icon="'$' + classPopUp"
                :text="textPopUp"
            ></v-alert>
            <form @submit.prevent="formSubmit" v-if="popup !== true">
                <label for="selectedDish">Выберете блюдо</label>
                <v-select
                    clearable
                    id="selectedDish"
                    v-model="selectDish"
                    :items="dishes"
                    variant="outlined"
                    :rounded="'rounded-pill'"   
                ></v-select>

                <label for="selectedGrade">Какую оценку нашему блюду дал гость?</label>
                <v-slider
                        id="selectedGrade"
                        color="#000"
                        track-color="#b2b2b2"
                        :step="0.1"
                        :min="0"
                        :max="0.5"
                        thumb-label="always"
                        v-model="grade"
                    >
                        <template v-slot:thumb-label="{ modelValue }">
                            {{ modelValue * 10 }}
                        </template>
                </v-slider>
                <label for="selectedGrade">Комментарий к оценке (кислое послевкусие, слишком сладкий, cyxoe мясо и пр...)</label>
                <v-textarea
                    id="selectedCommentDish"
                    variant="outlined"
                    v-model="comment"
                    rounded="rounded-xl"       
                ></v-textarea>
                <v-btn 
                    variant="tonal"
                    type="submit"
                    size="large"
                    :disabled="comment === '' ? true : false"
                    class="btn"
                >
                    Отправить
                </v-btn>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            selectDish: 'Тбилисо',
            dishes: [
                'Тбилисо',
                'Ахали',
                'Чашашули с говядиной',
                'Паштет из куриной печени',
                'Окрошка',
                'Цыпленок тапака',
                'Сердце атами',
                'Сладкие хинкали'
            ],
            grade: 0.3,
            comment: '',
            popup: false,
            textPopUp: '',
            classPopUp: ''
        }
    },
    methods: {
        async formSubmit() {
            const URI_API = `https://api.telegram.org/bot${process.env.VUE_APP_TOKEN}/sendMessage`

            let now = new Date();

            let message = `<b>Новая заявка!</b>\n`;
            message += `Позиция меню: <b>${this.selectDish}</b>\n`;
            message += `Оценка позиции: <b>${this.grade * 10}</b>\n`;
            message += `Комментарий: <b>${this.comment}</b>\n`;
            message += `\n`;
            message += `Заведение: <b>DJOS</b>\n`
            message += `Дата отправки <b>${now.getDate()}.${now.getMonth() + 1}.${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}</b>\n`;

            await axios.post(URI_API, {
                    chat_id: process.env.VUE_APP_CHAT_DJOS_ID,
                    parse_mode: "html",
                    text: message,
            })
            .then((res) => {
                    this.textPopUp = "Ваша заявка успешно отправленна!";
                    this.classPopUp = "success";
                    console.log(res);
            })
            .catch((err) => {
                    this.textPopUp = "Произошла какая-то ошибка! Попробуйте еще раз!";
                    this.classPopUp = "error";
                    console.log(err);
            });

            const formData = new FormData();
            formData.append('dish', this.selectDish)
            formData.append('grade', this.grade * 10)
            formData.append('comment', this.comment)
            formData.append('date', `${ now.getHours() }:${ now.getMinutes() < 10 ? '0'+ now.getMinutes() : now.getMinutes()} ${ now.getDate() }-${ now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1 }-${ now.getFullYear() }`);

            await axios.post(process.env.VUE_APP_GSHEETS_DJOS, formData)
            .then(result => {
                console.log('Данные успешно отправлены в таблицу:', result);
            })
            .catch(error => {
                console.error('Ошибка при отправке данных в таблицу:', error);
            });
            this.popup = true;

            this.selectDish = "Тарэлка к крепкому"
            this.grade = 0.3
            this.comment = ''
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=PT+Sans+Narrow:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap');

.bg {
    background-image: url('../assets/djos.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100%;
    max-height: fit-content;
    width: 100%;
    padding: 50px 0px;
}
.v-btn {
    display: flex;
    border: 0px;
    border-radius: 50px;
    background-color: #e6ff00;
    font-family: "PT Sans Narrow";
    font-size: 22px;
    font-weight: 600;
}

.v-btn--disabled {
    background-color: grey;
    color: black;
}

.v-btn.v-btn--density-default {
    height: 60px;
    width: 200px;
}
.btn {
    position: relative;
    margin: 0 auto;
}

.v-slider.v-input {
    margin-top: 30px;
}

#selectedDish[data-v-e50ac4b0] > .v-input__control > .v-field {
    border-radius: 50px !important;
}

h1 {
    font-family: "PT Sans Narrow";
    font-weight: 700;
    /* text-align: center; */
    text-transform: uppercase;
    font-size: 40px;
}

label {
    font-family: "PT Sans Narrow";
    font-size: 30px;
    font-weight: 500;
    color: #000;
}

@media (max-width: 1000px) {
    h1 {
        font-size: 30px;
    }

    label {
        font-size: 20px;
    }

    .v-btn {
        font-size: 16px;
    }

    .v-btn.v-btn--density-default {
        height: 40px;
        width: 160px;
    }
}

@media (max-width: 600px) {
    h1 {
        font-size: 24px;
    }

    label {
        font-size: 20px;
    }
}
</style>